const headRowsInvitationsUsers = {
  email: 'E-mail',
  role: 'Tipo de Acesso',
  site: 'Site',
  createdAt: 'Enviado Em',
  invitation: 'Link',
};

export default headRowsInvitationsUsers;
